import { Injectable, inject } from '@angular/core';
import { safeMap } from '@era/stores';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DeviceSyncStatusService } from '@rocksoft/apple-sync-sdk';
import { mergeMap } from 'rxjs/operators';
import { DeviceActiveSyncsApiActions, DeviceActiveSyncsResolverActions } from './devices-active-syncs.actions';

@Injectable()
export class DeviceActiveSyncsEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(DeviceSyncStatusService);

  deviceActiveSyncCountRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DeviceActiveSyncsResolverActions.deviceActiveSyncCountRequested),
      mergeMap(() =>
        safeMap(
          this.api.getCurrentActiveDeviceSyncs(),
          (count) => DeviceActiveSyncsApiActions.deviceActiveSyncCountLoaded({ currentActiveSyncs: count }),
          (error) => DeviceActiveSyncsApiActions.deviceActiveSyncCountLoadedError({ error })
        )
      )
    );
  });
}
